import { ReactNode } from 'react';
import { getSubComponent } from '../../utils/react.utils';
import BrandIcon from '../icons/brand.icon';
import { VStack } from './stack.layout';

const styles = {
  title: 'font-text text-3xl text-primary font-medium capitalize',
  container:
    'mobile-w-full mobile:px-2 tablet-sm:px-10 tablet-sm:w-[500px] h-screen justify-center mx-auto',
};

type Props = {
  title: string;
  children: ReactNode;
};

type SubComponentNames = 'Form' | 'Footer';

function AuthLayout({ title, children }: Props) {
  const Form = getSubComponent<SubComponentNames>(children, 'Form');
  const Footer = getSubComponent<SubComponentNames>(children, 'Footer');

  return (
    <VStack align="center" gap="lg" extensions={styles.container}>
      <BrandIcon size="lg" />
      <VStack align="center" extensions="w-full" gap="base">
        <div className={styles.title}>{title}</div>
        {Form}
      </VStack>
      {Footer}
    </VStack>
  );
}

type SCProps = {
  children: any;
};

const Form = (props: SCProps) => props.children;
Form.displayName = 'Form';

const Footer = (props: SCProps) => props.children;
Footer.displayName = 'Footer';

AuthLayout.Form = Form;
AuthLayout.Footer = Footer;

export default AuthLayout;
